import React from "react";
import { Link } from "react-router-dom";
import { usePageTitle } from "../lib/usePageTitle";

const COMPANY = {
  name: "STUFF CBD",
  address: "Rue de la Haute Boulaye, 27490 Autheuil-Authouillet",
  email: "contact@stuff.cbd",
  siret: "903 009 868",
  vat: "FR36 903009868",
};

const PAGES = {
  mentions: {
    title: "Mentions légales",
    blocks: [
      ["Éditeur du site", `Le site STUFF CBD est édité par ${COMPANY.name}, dont le siège est situé ${COMPANY.address}. Contact : ${COMPANY.email}. SIRET : ${COMPANY.siret}. TVA intracommunautaire : ${COMPANY.vat}.`],
      ["Directeur de la publication", "Le représentant légal de STUFF CBD."],
      ["Hébergement", "Le site est hébergé sur une infrastructure cloud sécurisée. Les données sont stockées sur des serveurs situés dans l'Union Européenne."],
      ["Produits", "Les produits proposés sont issus du chanvre (CBD) et contiennent moins de 0,3 % de THC, conformément à la réglementation française et européenne en vigueur. La vente est strictement réservée aux personnes majeures (18 ans et plus)."],
      ["Propriété intellectuelle", "L'ensemble des contenus du site (textes, logo STUFF, visuels) est protégé. Toute reproduction sans autorisation est interdite."],
    ],
  },
  cgv: {
    title: "Conditions Générales de Vente",
    blocks: [
      ["Objet", "Les présentes CGV régissent les ventes de produits CBD réalisées via la plateforme STUFF CBD entre les vendeurs indépendants et les clients."],
      ["Commande", "Le client passe commande en ligne en sélectionnant une boutique et des produits. La commande est finalisée directement avec le vendeur via WhatsApp ou Telegram. Aucun paiement en ligne n'est requis."],
      ["Prix & paiement", "Les prix sont indiqués en euros, TTC (TVA 20 % incluse). Le règlement s'effectue à la livraison, directement auprès du vendeur. Des frais de livraison peuvent s'appliquer selon la distance."],
      ["Livraison", "La livraison est assurée par le vendeur dans sa zone. Les délais sont indicatifs et communiqués par le vendeur."],
      ["Droit de rétractation", "Conformément à la réglementation, le droit de rétractation peut ne pas s'appliquer aux produits de consommation. Pour toute réclamation, contactez le vendeur ou STUFF CBD."],
      ["Âge légal", "La vente est interdite aux mineurs. Une pièce d'identité peut être demandée à la livraison."],
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    blocks: [
      ["Données collectées", "Nous collectons uniquement les données nécessaires au traitement des commandes : nom, téléphone, adresse de livraison et, le cas échéant, votre position pour le calcul des frais de livraison."],
      ["Utilisation", "Ces données servent exclusivement à préparer et livrer votre commande, à gérer votre programme de fidélité et à vous permettre de suivre vos commandes. Elles ne sont jamais revendues."],
      ["Conservation", "Les données sont conservées le temps nécessaire au suivi des commandes et aux obligations légales."],
      ["Vos droits", `Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Contactez-nous à ${COMPANY.email}.`],
      ["Cookies", "Le site utilise le stockage local du navigateur pour mémoriser votre panier, votre session et la confirmation d'âge. Aucun cookie publicitaire ou de traçage tiers n'est utilisé."],
    ],
  },
};

export default function Legal({ page }) {
  const p = PAGES[page] || PAGES.mentions;
  usePageTitle(`${p.title} — STUFF CBD`);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid={`legal-${page}`}>
      <h1 className="font-anton text-4xl sm:text-5xl uppercase text-white mb-8">{p.title}</h1>
      <div className="space-y-6">
        {p.blocks.map(([h, body]) => (
          <section key={h}>
            <h2 className="font-anton text-lg uppercase text-neon-green mb-1">{h}</h2>
            <p className="text-zinc-400 text-sm leading-relaxed">{body}</p>
          </section>
        ))}
      </div>
      <p className="text-zinc-600 text-xs mt-10">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}. Réservé aux personnes majeures (18+).</p>
      <Link to="/" className="inline-block mt-4 text-neon-green uppercase text-sm font-semibold hover:text-neon-magenta">← Retour à l'accueil</Link>
    </div>
  );
}
